export default __webpack_public_path__ + "static/media/camera-icn.a08f2a2a.svg";